
import React from 'react';
import { Link } from 'react-router-dom';

interface ListingCardProps {
  id: number;
  facility_name: string;
  location: string;
  week_count: number;
  cover_image: string;
  price?: number;
  isNew?: boolean;
  createdAt?: string;
}

export const ListingCard: React.FC<ListingCardProps> = ({
  id,
  facility_name,
  location,
  week_count,
  cover_image,
  price,
  isNew = false,
  createdAt,
}) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now.getTime() - date.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays <= 1) return 'Bugün';
    if (diffDays <= 2) return 'Dün';
    if (diffDays <= 7) return `${diffDays} gün önce`;
    if (diffDays <= 30) return `${Math.floor(diffDays / 7)} hafta önce`;
    if (diffDays <= 60) return '1 ay önce';
    return `${Math.floor(diffDays / 30)} ay önce`;
  };

  return (
    <div className="bg-white border border-[#E5E9F0] rounded-2xl overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer">
      <Link to={`/ilan/${id}`}>
        <div className="relative aspect-[16/10] overflow-hidden">
          <img
            src={cover_image}
            alt={facility_name}
            className="w-full h-full object-cover object-top"
          />
          {isNew && (
            <div className="absolute top-4 left-4 bg-[#D4AF37] text-white text-xs font-semibold px-3 py-1 rounded-full">
              YENİ
            </div>
          )}
          {price && (
            <div className="absolute top-4 right-4 bg-white/90 text-[#0A1628] text-sm font-semibold px-3 py-2 rounded-lg">
              {price.toLocaleString('tr-TR')} ₺
            </div>
          )}
        </div>

        <div className="p-6">
          <h3 className="text-xl font-semibold text-[#0A1628] mb-3 truncate">
            {facility_name}
          </h3>

          <div className="flex items-center text-[#6B7A90] text-sm mb-3">
            <i className="ri-map-pin-line text-base mr-2"></i>
            <span>{location}</span>
          </div>

          <div className="flex items-center justify-between mb-4">
            <div className="inline-block bg-[#FFF8E7] text-[#D4AF37] font-semibold text-sm px-3 py-1.5 rounded-full">
              <i className="ri-calendar-line mr-1.5"></i>
              {week_count} Hafta
            </div>
            {createdAt && (
              <div className="flex items-center text-[#6B7A90] text-xs">
                <i className="ri-time-line mr-1"></i>
                {formatDate(createdAt)}
              </div>
            )}
          </div>

          <button className="w-full h-11 border-2 border-[#0A1628] text-[#0A1628] font-medium rounded-full hover:bg-[#0A1628] hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer">
            Detay
          </button>
        </div>
      </Link>
    </div>
  );
};
